import { checkResponse, errorHandler, getUrl } from '@/api/utils/http-helpers.js'
import axios from 'axios'

const USER_LOG_IN = 'USER_LOG_IN'
const USER_LOG_OUT = 'USER_LOG_OUT'
const START = 'START'
const END = 'END'
const ASSIGN_USER_PERMISSIONS = 'ASSIGN_USER_PERMISSIONS'
const ASSIGN_ALL_USER_PROFILES = 'ASSIGN_ALL_USER_PROFILES'

const initialState = {
  userData: {},
  allUserProfiles: [],
  userPermissions: [],
  invalidCredentials: false,
  isLoggedIn: false,
  isLoggingIn: false,
  preSelectedUserProfile: 'basic'
}

const state = { ...initialState }

// Getters
const getters = {
  userData (state) {
    return state.userData
  },
  userPermissions (state) {
    return state.userPermissions
  },
  invalidCredentials (state) {
    return state.invalidCredentials
  },
  allUserProfiles (state) {
    return state.allUserProfiles
  },
  preSelectedUserProfile (state) {
    return state.preSelectedUserProfile
  }
}

// Actions
const actions = {
  async userLogin ({ commit }, payload) {
    const url = getUrl(`/user/login`)
    commit('START')
    await axios
      .post(url, payload, { withCredentials: true })
      .then((response) => {
        checkResponse(response)
        commit('USER_LOG_IN', response.data)
        commit('ASSIGN_USER_PERMISSIONS', response.data.permissions)
        commit('END')
        state.invalidCredentials = false
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        const errStatus = error.response.status
        if (errStatus === 400 && error.response.data.message === 'Invalid user info') {
          state.invalidCredentials = true
        }
      })
  },

  async getAllUserProfiles ({ commit }) {
    const url = getUrl('/user')
    commit('START')
    await axios
      .get(url)
      .then((response) => {
        checkResponse(response)
        commit('ASSIGN_ALL_USER_PROFILES', [...response.data])
        commit('END')
      })
      .catch(error => {
        errorHandler(error)
      })
  },

  async logoutUser ({ commit }) {
    const url = getUrl(`/user/logout`)
    commit('START')
    await axios
      .post(url, { withCredentials: true })
      .then((response) => {
        checkResponse(response)
        commit('USER_LOG_OUT')
        commit('END')
      })
      .catch(error => {
        errorHandler(error)
      })
  },

  async updateUserData ({ commit }, payload) {
    const url = getUrl(`/user/${payload.id}`)
    const updateUserData = {
      loginRequired: payload.loginRequired
    }
    await axios.patch(url, updateUserData)
  },

  async updateUserPassword ({ commit }, payload) {
    const url = getUrl(`/user/update-password`)
    await axios.post(url, payload)
  },

  async getUserInfo ({ commit }) {
    const url = getUrl('/user-info')
    commit('START')
    await axios
      .get(url, { withCredentials: true })
      .then((response) => {
        checkResponse(response)
        commit('USER_LOG_IN', response.data)
        commit('ASSIGN_USER_PERMISSIONS', response.data.permissions)
        commit('END')
        state.invalidCredentials = false
      })
      .catch(error => {
        errorHandler(error)
        // eslint-disable-next-line
        const errStatus = error.response.status
        if (errStatus === 400 && error.response.data.message === 'Invalid user info') {
          state.invalidCredentials = true
        }
      })
  }
}

// Mutations
const mutations = {
  [START] (state) {
    state.isLoggedIn = false
    state.isLoggingIn = true
  },

  [END] (state) {
    state.isLoggingIn = false
    state.isLoggedIn = true
  },

  [USER_LOG_IN] (state, payload) {
    state.userData = Object.assign({}, state.userData, payload)
  },

  [USER_LOG_OUT] (state) {
    state.userData = {}
    state.userPermissions = []
    state.invalidCredentials = false
  },

  [ASSIGN_USER_PERMISSIONS] (state, payload) {
    state.userPermissions = payload
  },

  [ASSIGN_ALL_USER_PROFILES] (state, payload) {
    state.allUserProfiles = payload.map(p => Object.assign({}, p))
  },

  setInvalidCredentials (state, value) {
    state.invalidCredentials = value
  },

  setPreselectedUserProfile (state, value) {
    state.preSelectedUserProfile = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
